import { render } from "./FormPenerimaan.vue?vue&type=template&id=bd37b72a"
import script from "./FormPenerimaan.vue?vue&type=script&lang=js"
export * from "./FormPenerimaan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__